export default "__VITE_ASSET__Crk7$UMb__"